<script setup lang="js">
import { RouterView } from 'vue-router'
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue'
import { Tenants } from '@/models/tenants/Tenants.js'

import { themes } from '@/assets/themes/theme.js'
import { useFavicon} from '@vueuse/core'
import { useAuthSync } from '@/composables/useAuthSync.js'
import { systemEchoes } from '@/composables/echo/useSystemEchoes.js'

onBeforeMount(() => {
	themes.applyTheme()
});

//Logging out in one tab signs this one out too
useAuthSync()

const icon = ref(Tenants.getFavIconPath())
useFavicon(icon,{
	baseUrl: '/',
	rel: 'icon',
})

onMounted(() => {
	systemEchoes.systemConnect();
})

onUnmounted(() => {
	systemEchoes.systemDisconnect();
})
</script>

<template>
	<RouterView />
</template>